module.exports = __webpack_public_path__ + "static/selected-language-mobile@3x-b323daa9a05bb76e26d90bef790cc946.png";